// extracted by mini-css-extract-plugin
export default {"container":"ResetPasswordModal_container__TP3QF"};